import type { ReactNode } from "react";
import { useEffect } from "react";
import { GET_LEAVING_QUESTIONNAIRES } from "../../pages/Homepage/LeavingQuestionnaire/gql";
import { useQuery } from "@apollo/client";
import useUserStore from "../../store/userStore";
import Navigation from "../Navigation";
import { useScrollToTop } from "../../hooks/useScrollToTop";

const AuthorizedLayout = ({ children }: { children: ReactNode }) => {
  useScrollToTop();

  const { data } = useQuery(GET_LEAVING_QUESTIONNAIRES);
  const { setHasLeavingQuestionnaire } = useUserStore();

  useEffect(() => {
    setHasLeavingQuestionnaire(
      (data?.leavingQuestionnaires?.length ?? 0) > 0
    );
  }, [data, setHasLeavingQuestionnaire]);

  return (
    <>
      <Navigation />

      {children}
    </>
  );
};

export default AuthorizedLayout;
